/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import Icon from "@mdi/react";
import { mdiLoading } from "@mdi/js";

const Button = ({ children, isLoading, ...props }) => (
  <button disabled={isLoading} {...props}>
    {isLoading ? (
      <>
        <Icon size={1.2} spin={true} path={mdiLoading} color="#fff" />
        <p>Loading...</p>
      </>
    ) : (
      children
    )}
  </button>
);

export default Button;
